import React, { createContext, useState, useEffect, useContext } from 'react';
import { getToken, removeToken, setToken } from '../service/auth';
import api from '../service/api';
import { Spinner } from 'reactstrap';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIstloading] = useState(true);
  const token = getToken();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        if (token) {
          const response = await api.get('/auth/profile');

          const baseUser = response.data.user;

          const imports = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Imports')
            .map(permission => permission.permission)
            : [];
          const exports = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Exports')
            .map(permission => permission.permission)
            : [];
          const finances = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Finances')
            .map(permission => permission.permission)
            : [];
          const reports = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Reports')
            .map(permission => permission.permission)
            : [];
          const activity_logs = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Activity logs')
            .map(permission => permission.permission)
            : [];
          const accounts = response.data.user.permissions ? response.data.user.permissions
            .filter(permission => permission.function === 'Accounts')
            .map(permission => permission.permission)
            : [];

          setUser({
            id: baseUser.id,
            name: baseUser.name,
            email: baseUser.email,
            imports,
            exports,
            finances,
            reports,
            activity_logs,
            accounts
          });
          
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Erro ao buscar perfil do usuário:', error);
        setUser(null);
      } finally {
        setIstloading(false);
      }
    };
    fetchUserProfile();
  }, [token]);

  const login = async (user, token) => {
    try {
      setUser(user);
      setToken(token);
    } catch (error) {
      console.error('Erro ao fazer login:', error);
    }
  };

  const logout = () => {
    removeToken();
    setUser(null);
  };

  if (isLoading) {
    return <div className='vh-100 d-flex align-items-center justify-content-center'><Spinner size={"sm"} /></div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
